export interface IAccountSitesResponse {
  accountId: number;
  sites: IAccountSite[];
}

export interface IAccountSite {
  siteId: number;
  siteName: string;
  products: ISiteProduct[];
}

export class AccountSite implements IAccountSite {
  siteId: number;
  siteName: string;
  products: ISiteProduct[];

  constructor(data: IAccountSite) {
    this.siteId = data.siteId;
    this.siteName = data.siteName;
    this.products = data.products.map((product) => new SiteProduct(product));
  }
}

export interface ISiteProduct {
  name: string;
  productId: number;
  abbreviation: string;
}

class SiteProduct implements ISiteProduct {
  name: string;
  productId: number;
  abbreviation: string;

  constructor(data: ISiteProduct) {
    this.name = data.name;
    this.productId = data.productId;
    this.abbreviation = data.abbreviation;
  }
}
